<template>
  <div>
    <el-select
      :value="selectValue"
      @clear="handleClear"
      :clearable="clearable"
      ref="select"
    >
      <el-option :value="null" class="pagoda-tow-tile-select">
        <div class="option-box" ref="optionBox" @click.stop :style="{width: (110 * rowCount) + 'px'}">
          <el-container v-for="it in options" :key="it[valueKey]">
            <el-aside @click.stop width="110px">
              {{it[labelKey]}} <i class="el-icon-arrow-right"></i>
            </el-aside>
            <el-main>
              <div
                :title="item[labelKey]"
                v-for="item in it[childrenKey]"
                :key="item[valueKey]"
                class="content"
                :class="{active: item.bol}"
                @click="selectChange(it[valueKey], item[valueKey])"
              >{{item[labelKey]}}</div>
            </el-main>
          </el-container>
        </div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
  import {
    getEmptyArray,
    getEmptyObject,
    isArray
  } from "../../utils";
  export default {
    name: 'TowTileSelect',
    props: {
      labelKey: {
        type: String,
        default: 'label'
      },
      valueKey: {
        type: String,
        default: 'value'
      },
      childrenKey: {
        type: String,
        default: 'children'
      },
      data: {
        type: Array,
        default: getEmptyArray
      },
      value: {
        type: Array,
        default: getEmptyArray
      },
      rowCount: {
        type: Number,
        default: 4
      },
      separator: {
        type: String,
        default: '/'
      },
      showAllLevels: {
        type: Boolean,
        default: true
      },
      clearable: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        selectValue: '',
        options: JSON.parse(JSON.stringify(this.data)),
        obj: JSON.parse(JSON.stringify(this.data)),
        isValue: false,
        scrollVal: 0
      }
    },
    created () {
      // 回显定位
      if (this.value && this.value.length) {
        this.location(this.options, this.value)
      }
    },
    methods: {
      // 二级选择
      selectChange (val1, val2) {
        // 重置树，清空bol值
        this.options = JSON.parse(JSON.stringify(this.obj))
        this.location(this.options, [val1, val2])
        this.$refs.select.toggleMenu()
      },
      // 回显位置方法
      location (data, val) {
        for (let i of data) {
          if (i[this.valueKey] === val[0]) {
            if (i[this.childrenKey]) {
              for (let j of i[this.childrenKey]) {
                if (j[this.valueKey] === val[1]) {
                  j.bol = true
                  this.selectValue = j[this.labelKey]
                  if (this.showAllLevels) {
                    this.selectValue = `${i[this.labelKey]}${this.separator}${j[this.labelKey]}`
                  }
                  // 更新v-model的值
                  this.$emit('input', val)
                  break
                }
              }
            }
          }
        }
      },
      // 清空方法
      handleClear () {
        this.selectValue = ''
        this.$emit('input', [])
        this.options = JSON.parse(JSON.stringify(this.obj))
      },
    },
    watch: {
      data: {
        handler (val) {
          this.options = JSON.parse(JSON.stringify(val))
          this.obj = JSON.parse(JSON.stringify(val))
          this.location(this.options, this.value)
        },
        deep:true
      },
      value: {
        handler (val) {
          if (!this.isValue) {
            this.isValue = true
            this.location(this.options, val)
          }
        },
        deep:true
      }
    }
  }
</script>
<style scoped>
  .el-select-dropdown__item {
    height: auto;
    background: #fff;
  }
  .el-select-dropdown__item.hover {
    background: #fff;
  }
</style>
